import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API } from "../../../constants/apiPath";
import axios from "axios";
import { useDispatch } from "react-redux";
import { startLoading, stopLoading } from "../loader/loaderSlice";

const initialState = {
  products: [],
  productDetail: {},
  customizeddetails: {},
  isLoading: false,
  pageInfo: {},
  availablesizes: [],
  availableColors: [],
    // 🔥 Pagination
  pageInfo: {
    total: 0,
    page: 1,
    limit: 15,
    pages: 0,
  },
  vaultproducts: [],
  displayproducts: [],
  bestsellerproducts: [],
  senddesignproducts: [],
  minValue: 0,
  maxValue: 1000,
  availableTags: [],
  recommendedprods: [],
};
const THUNK_METHODS = {
  PRODUCT_LISTS: "user/products",
  PRODUCT_DETAIL: "user/productDetail",
  PRODUCT_FILTER: "user/filterproducts",
  PRODUCT_COLLECTION: "user/collections/product",
  PRODUCT_SALE: "user/sale",
  CATEGORY_DETAILS: "user/category/details",
  CUSTOMIZE: "user/product/customize",
  GET_VAULT_PRODUCTS: "user/product/vault",
  GET_DISPLAY_PRODUCTS: "user/product/display",
  GET_BEST_PRODUCTS: "user/product/bestseller",
  GET_SEND_DESIGN_PRODUCTS:  "user/product/senddesign",
  RECOMMENDED_PRODS: "user/produce/recommended",
};

export const getProductList = createAsyncThunk(
  THUNK_METHODS.PRODUCT_LISTS,
  async (accessToken, { dispatch, rejectWithValue }) => {
    try {
      dispatch(startLoading());
      const { data } = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_URL}${API.PRODUCT.PRODUCTLISTS}`,
        withCredentials: true,
      });
      return data;
    } catch (error) {
      console.error(error.message);
      return rejectWithValue("SignUp failed");
    } finally {
      dispatch(stopLoading());
    }
  }
);

export const getproductDetails = createAsyncThunk(
  THUNK_METHODS.PRODUCT_DETAIL,
  async (productId, { dispatch, rejectWithValue }) => {
    try {
      dispatch(startLoading());
      const { data } = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_URL}${API.PRODUCT.PRODUCTDETAIL}/${productId}`,
        withCredentials: true,
      });
      return data.product;
    } catch (error) {
      console.error(error.message);
      return rejectWithValue("SignUp failed");
    } finally {
      dispatch(stopLoading());
    }
  }
);


export const getFilterProducts = createAsyncThunk(
  THUNK_METHODS.PRODUCT_FILTER,
  async (filterjson, { dispatch, rejectWithValue }) => {
    try {
      dispatch(startLoading());

      const { data } = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_API_URL}${API.PRODUCT.PRODUCTFILTER}`,
        withCredentials: true,
        data: filterjson,
      });


      return {
        ...data,

        // 🔥 Keep this so reducer knows whether
        // to replace or append products
        append: filterjson?.append === true,
      };

    } catch (error) {
      console.error(error.message);

      return rejectWithValue(
        error.response?.data?.message ||
        "Failed to fetch products"
      );
    } finally {
      dispatch(stopLoading());
    }
  }
);

export const getCategoryDetails = createAsyncThunk(
  THUNK_METHODS.CATEGORY_DETAILS,
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      dispatch(startLoading());
      const { data } = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_API_URL}${API.PRODUCT.CATEGORYDETAILS}`,
        withCredentials: true,
        data: payload
      });
      return data;
    } catch (error) {
      console.error(error.message);
      return rejectWithValue("SignUp failed");
    } finally {
      dispatch(stopLoading());
    }
  }
);

export const getCollectionProducts = createAsyncThunk(
  THUNK_METHODS.PRODUCT_COLLECTION,
  async (collectionType, { dispatch, rejectWithValue }) => {
    try {
      dispatch(startLoading());
      const { data } = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_URL}${API.PRODUCT.PRODUCTCOLLECTION}?collectionType=${collectionType}`,
        withCredentials: true,
      });
      return data;
    } catch (error) {
      console.error(error.message);
      return rejectWithValue("SignUp failed");
    } finally {
      dispatch(stopLoading());
    }
  }
);

export const getSaleProducts = createAsyncThunk(
  THUNK_METHODS.PRODUCT_SALE,
  async (args, { dispatch, rejectWithValue }) => {
    try {
      dispatch(startLoading());
      const { data } = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_URL}${API.PRODUCT.PRODUCTSALE}`,
        withCredentials: true,
      });
      return data;
    } catch (error) {
      console.error(error.message);
      return rejectWithValue("SignUp failed");
    } finally {
      dispatch(stopLoading());
    }
  }
);

export const getCustomizedDetails = createAsyncThunk(
  THUNK_METHODS.CUSTOMIZE,
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      dispatch(startLoading());
      const { data } = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_API_URL}${API.PRODUCT.CUSTOMIZE}/${payload.productId}`,
        withCredentials: true,
        data: payload,
      });
      return data;
    } catch (error) {
      console.error(error.message);
      return rejectWithValue("SignUp failed");
    } finally {
      dispatch(stopLoading());
    }
  }
);

export const getVaultProducts = createAsyncThunk(

  
    THUNK_METHODS.GET_VAULT_PRODUCTS,
  async (accessToken, { dispatch, rejectWithValue }) => {
    try {
      dispatch(startLoading());
      const { data } = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_URL}${API.PRODUCT.GET_VAULT_PRODUCTS}`,
        withCredentials: true,
      });
      return data;
    } catch (error) {
      console.error(error.message);
      return rejectWithValue("Failed to get Vault Products failed");
    } finally {
      dispatch(stopLoading());
    }
  }
);




export const getDisplayProducts = createAsyncThunk(

  
    THUNK_METHODS.GET_DISPLAY_PRODUCTS,
  async (accessToken, { dispatch, rejectWithValue }) => {
    try {
      dispatch(startLoading());
      const { data } = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_URL}${API.PRODUCT.GET_DISPLAY_PRODUCTS}`,
        withCredentials: true,
      });
      return data;
    } catch (error) {
      console.error(error.message);
      return rejectWithValue("Failed to get Vault Products failed");
    } finally {
      dispatch(stopLoading());
    }
  }
);


export const getBestSellerProducts = createAsyncThunk(

  
    THUNK_METHODS.GET_BEST_PRODUCTS,
  async (accessToken, { dispatch, rejectWithValue }) => {
    try {
      dispatch(startLoading());
      const { data } = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_URL}${API.PRODUCT.GET_BEST_PRODUCTS}`,
        withCredentials: true,
      });
      return data;
    } catch (error) {
      console.error(error.message);
      return rejectWithValue("Failed to get Vault Products failed");
    } finally {
      dispatch(stopLoading());
    }
  }
);


export const getSendDesignProducts = createAsyncThunk(

  
    THUNK_METHODS.GET_SEND_DESIGN_PRODUCTS,
  async (accessToken, { dispatch, rejectWithValue }) => {
    try {
      dispatch(startLoading());
      const { data } = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_URL}${API.PRODUCT.GET_SEND_DESIGN_PRODUCTS}`,
        withCredentials: true,
      });
      return data;
    } catch (error) {
      console.error(error.message);
      return rejectWithValue("Failed to get Vault Products failed");
    } finally {
      dispatch(stopLoading());
    }
  }
);


export const getRecommendedProducts = createAsyncThunk(
  THUNK_METHODS.RECOMMENDED_PRODS,
  async (productId, { rejectWithValue }) => {
    try {
       const { data } = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_URL}${API.PRODUCT.RECOMMENDED_PRODS}/${productId}`,
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
        "Failed to fetch recommendations"
      );
    }
  }
);


export const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    resetCustomizedDetails: (state) => {
      state.customizeddetails = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProductList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getProductList.fulfilled, (state, action) => {
      state.products = action.payload.products;
      state.pageInfo = action.payload.pageInfo;
      state.isLoading = false;
    });
    builder.addCase(getProductList.rejected, (state) => {
      state.isLoading = false;
    });

    builder.addCase(getproductDetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getproductDetails.fulfilled, (state, action) => {
      state.productDetail = action.payload;
      state.isLoading = false;
    });
    builder.addCase(getproductDetails.rejected, (state) => {
      state.isLoggedIn = false;
    });
    builder.addCase(getFilterProducts.pending, (state) => {
      state.isLoading = true;
    });
   builder.addCase(getFilterProducts.fulfilled, (state, action) => {

  const {
    products = [],
    total = 0,
    page = 1,
    limit = 20,
    pages = 0,
    append = false,
  } = action.payload;

  if (append) {
    state.products = [
      ...state.products,
      ...products,
    ];
  } else {
    state.products = products;
  }

  state.pageInfo = {
    total,
    page,
    limit,
    pages,
  };

  state.isLoading = false;
});

    builder.addCase(getFilterProducts.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getCategoryDetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getCategoryDetails.fulfilled, (state, action) => {
      state.availablesizes = action.payload.sizes;
      state.availableColors = action.payload.colors;
      state.minValue = action.payload.minPrice;
      state.maxValue = action.payload.maxPrice;
      state.availableTags = action.payload.tags;
      state.isLoading = false;
    });

    builder.addCase(getCategoryDetails.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getSaleProducts.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getSaleProducts.fulfilled, (state, action) => {
      state.products = action.payload.products;
    });
    builder.addCase(getSaleProducts.rejected, (state) => {
      state.isLoading = false;
    });

    builder.addCase(getCustomizedDetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getCustomizedDetails.fulfilled, (state, action) => {
      state.customizeddetails = action.payload;
      state.isLoading = false;
    });
    builder.addCase(getCustomizedDetails.rejected, (state) => {
      state.isLoading = false;
    });

    builder.addCase(getVaultProducts.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getVaultProducts.fulfilled, (state, action) => {
      state.vaultproducts = action.payload.vaultproducts;
      state.isLoading = false;
    });
    builder.addCase(getVaultProducts.rejected, (state) => {
      state.isLoading = false;
    });

    builder.addCase(getDisplayProducts.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getDisplayProducts.fulfilled, (state, action) => {
      state.displayproducts = action.payload.displayproducts;
      state.isLoading = false;
    });
    builder.addCase(getDisplayProducts.rejected, (state) => {
      state.isLoading = false;
    });

    builder.addCase(getBestSellerProducts.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getBestSellerProducts.fulfilled, (state, action) => {
      state.bestsellerproducts = action.payload.bestsellerproducts;
      state.isLoading = false;
    });
    builder.addCase(getBestSellerProducts.rejected, (state) => {
      state.isLoading = false;
    });

    builder.addCase(getSendDesignProducts.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getSendDesignProducts.fulfilled, (state, action) => {
      state.senddesignproducts = action.payload.senddesignproducts;
      state.isLoading = false;
    });
    builder.addCase(getSendDesignProducts.rejected, (state) => {
      state.isLoading = false;
    });

    builder.addCase(getRecommendedProducts.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getRecommendedProducts.fulfilled, (state, action) => {
      state.recommendedprods = action.payload.products;
      state.isLoading = false;
    });
    builder.addCase(getRecommendedProducts.rejected, (state) => {
      state.isLoading = false;
    });
  },


});
export const { resetCustomizedDetails } = productSlice.actions;
